import React from 'react';
import { Flex, Padding } from 'components/base/layout-components';
import MenuButton, {
  MenuButtonItem,
  ICON_POSITIONS
} from 'components/MenuButton';
import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';
import Icon from 'components/base/Icon';
import withGitIntegrationsModals from '../gitIntegrations/withGitIntegrationsModals';
import useAutoRepoDiscoveryFF from './useAutoRepoDiscoveryFF';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import sensorAuthorizationStates from 'common/constants/sensorAuthorizationStates';

const IntegrationMenu = withGitIntegrationsModals(
  ({
    stateOK,
    isTeamLicense,
    toggleModal,
    account,
    toggleSnackBar,
    integrationId,
    name,
    sensor_name,
    url,
    gitIntegrations,
    getSensorAuthorizations,
    getRepositories,
    deleteSensorAuthorization,
    openReauthorizeModal,
    deleteGitIntegrationFF,
    isMultiTokenEnabled,
    isOnPrem,
    onDeleteIntegrationClick
  }) => {
    const history = useHistory();
    const autoRepoDiscoveryEnabled = useAutoRepoDiscoveryFF(sensor_name);
    const shouldShowDeleteIntegration =
      account.type_id === ACCOUNT_TYPES_MAP.Primary &&
      !isTeamLicense &&
      deleteGitIntegrationFF;

    const isTheOnlyActiveIntegration =
      gitIntegrations?.filter(
        gitIntegration =>
          gitIntegration?.id !== integrationId &&
          gitIntegration?.state === sensorAuthorizationStates.OK
      )?.length === 0;

    const hasMenuAccess =
      account.type_id === ACCOUNT_TYPES_MAP.Primary ||
      account.type_id === ACCOUNT_TYPES_MAP.SuperUser ||
      shouldShowDeleteIntegration;

    if (!hasMenuAccess) {
      return <></>;
    }

    return (
      <Flex
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <MenuButton
          items={[
            account.type_id === ACCOUNT_TYPES_MAP.Primary && (
              <MenuButtonItem
                key='git-reauth'
                disabled={isOnPrem}
                iconPos={ICON_POSITIONS.afterText}
                {...(!stateOK
                  ? {
                      icon: (
                        <Padding l='small'>
                          <Icon name='ErrorIcon' color='torchRed' />
                        </Padding>
                      )
                    }
                  : {})}
                text={isMultiTokenEnabled ? 'Manage Tokens' : 'Reauthorize Git'}
                onClick={e => {
                  openReauthorizeModal({
                    id: integrationId,
                    sensor_name,
                    url,
                    gitIntegrations,
                    toggleModal,
                    getSensorAuthorizations
                  });
                  e.preventDefault();
                  e.stopPropagation();
                }}
              />
            ),
            autoRepoDiscoveryEnabled && (
              <MenuButtonItem
                text='Monitoring Rules'
                key='monitoring-rules'
                onClick={() =>
                  history.push(
                    AppRouter.GIT_INTEGRATION_MONITORING_RULES.getLink(
                      integrationId
                    )
                  )
                }
              />
            ),
            shouldShowDeleteIntegration ? (
              <MenuButtonItem
                text='Delete integration'
                key='delete-integration'
                onClick={() => onDeleteIntegrationClick(integrationId)}
                {...(isTheOnlyActiveIntegration && {
                  disabled: true,
                  tooltipText:
                    'This is your only active integration. Add another before deleting.'
                })}
              />
            ) : null
          ].filter(Boolean)}
        />
      </Flex>
    );
  }
);

export default IntegrationMenu;
